import React from 'react'
import './define.css'
import GADGET1 from '../../assets/2nobelt.png'
import GADGET2 from '../../assets/3noplate.png'
import GADGET3 from '../../assets/1nohelm.png'
import GADGET4 from '../../assets/4gadget.png'

const data = [
  {
    avatar: GADGET1,
    name: 'No Belt',
  },
  {
    avatar: GADGET2,
    name: 'No Chestplate',
  },
  {
    avatar: GADGET3,
    name: 'No Covered Helmet',
  },
  {
    avatar: GADGET4,
    name: 'One or more of any other gadget',
  },
]

const Define = () => {
  return (
    <section id='define'>
    <h5>Defining</h5>
    <h2>GX</h2>

    <div className="container definechart__container">
      {
        data.map(({avatar, name}, index) => {
          return (
            <article key={index} className="definecharts">
              <div className="define__avatar">
                <img src={avatar} alt={name} />
              </div>
              <h5 className='define__name'>{name}</h5>
            </article>
          )
        })
      }
    </div>

      
    </section>
  )
}

export default Define